import React from 'react'
import "./color.css"

function RedHC() {
    var x = localStorage.getItem("percentage hc")
    return (
        <div className = "red__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default RedHC
